import React from "react";
import { Star } from "lucide-react";
import Reveal from "./Reveal";
import { TESTIMONIALS } from "../data/data";

export function Testimonials() {
  return (
    <section className="py-24 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="uppercase tracking-widest text-xs mb-3 text-center" style={{ fontFamily: "'JetBrains Mono', monospace", color: "#1E9AFF" }}>
            Reviews
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 style={{ fontFamily: "Fraunces, serif" }} className="text-4xl md:text-5xl mb-14 text-center">What shoppers say</h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <div className="rounded-2xl p-8 h-full flex flex-col" style={{ background: "#171B22", border: "1px solid rgba(255,255,255,0.06)" }}>
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: 5 }).map((_, idx) => (
                    <Star key={idx} size={14} color="#FF8A00" fill={idx < t.rating ? "#FF8A00" : "none"} />
                  ))}
                </div>
                <p className="text-sm leading-relaxed opacity-80 mb-6 flex-1">"{t.quote}"</p>
                <div>
                  <p style={{ fontFamily: "Fraunces, serif" }} className="text-base">{t.name}</p>
                  <p className="text-xs opacity-50 uppercase tracking-widest" style={{ fontFamily: "'JetBrains Mono', monospace" }}>{t.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
